import apiClient from "./axios"

// Get all vehicle fuel stocks with optional filtering
export const getVehicleFuelStocks = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-stocks", { params })
  return data
}

// Get a specific vehicle fuel stock by ID
export const getVehicleFuelStock = async id => {
  const { data } = await apiClient.get(`/vehicle-fuel-stocks/${id}`)
  return data
}

// Create a new vehicle fuel stock
export const createVehicleFuelStock = async stockData => {
  const { data } = await apiClient.post("/vehicle-fuel-stocks", stockData)
  return data
}

// Update an existing vehicle fuel stock
export const editVehicleFuelStock = async ({ id, ...stockData }) => {
  const { data } = await apiClient.patch(`/vehicle-fuel-stocks/${id}`, stockData)
  return data
}

// Delete a vehicle fuel stock (soft delete)
export const deleteVehicleFuelStock = async id => {
  const { data } = await apiClient.delete(`/vehicle-fuel-stocks/${id}`)
  return data
}

// Get all vehicle fuel stocks without pagination
export const getAllVehicleFuelStocks = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-stocks", {
    params: { ...params, all: true },
  })
  return data
}

// Search vehicle fuel stocks by remarks, fuel type, or purchaser
export const searchVehicleFuelStocks = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-stocks", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed vehicle fuel stocks
export const getTrashedVehicleFuelStocks = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-stocks/trashed", { params })
  return data
}

// Restore a trashed vehicle fuel stock
export const restoreVehicleFuelStock = async id => {
  const { data } = await apiClient.post(`/vehicle-fuel-stocks/${id}/restore`)
  return data
}
